module.exports = __webpack_public_path__ + "static/media/1750-point-season.60672bcd.png";